import React, { useEffect, useState, useContext } from "react";
import useCeo from "../../hooks/useCEO";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Row,
  Col,
} from "reactstrap";
import $ from "jquery";
import Accordion from "react-bootstrap/Accordion";
import classnames from "classnames";
import { useUnidades } from "../../hooks/test/useUnidades";
import moment from "moment";
import "moment/locale/es-mx";
import axios from "axios";
import fileDownload from "js-file-download";
import { PDFViewer } from "@react-pdf/renderer";
import { DocuPDFEventoSeguridad } from "../../models/DocuPDFEventoSeguridad";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import { Spinner } from "../../components/Spinner";
import Select from "react-select";
import DocPDFEventoSeguridad from "../../models/DocPDFEventoSeguridad";
import { SocketContext } from "../../context/SocketContext";

export const EventosSeguridad = () => {
  useCeo({
    title: "Eventos de seguridad",
    description: "Página de eventos de seguridad",
  });

  moment.locale("es-mx");
  const {
    getRegistroSeguridadEventos,
    getStatusEvento,
    postEventoSeguridad,
    postFilesUploads,
    deleteRegistroEventoSeguridad,
    getTipoApoyo,
    postValidarArchivo,
  } = useUnidades();
  const { socket } = useContext(SocketContext);
  const [unidadEventSeguridad, setUnidadEventSeguridad] = useState([]);
  const [registroSeguridadEventos, setRegistroSeguridadEventos] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const [tipoApoyo, setTipoApoyo] = useState([]);
  const [statusEventoAutos, setStatusEventoAutos] = useState([]);
  const [statusEventoMotos, setStatusEventoMotos] = useState([]);
  const [statusEventoCamiones, setStatusEventoCamiones] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const timers = require("timers-promises");
  const [loading, setLoading] = useState(false);
  const [verPDF, setVerPdf] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleClose = () => {
    setShow2(false);
    setSelectedFile(null);
  };
  const handleShow = () => setShow2(true);
  const [form, setForm] = useState({
    nombre_evento: "",
    estatus_evento_id: "",
    observaciones: "",
    evento_seguridad_id: "",
    lugar_remitido: "",
    tipo_de_apoyo: [],
    fechaAct: new Date().toLocaleString("es-MX", "America/Mexico_City"),
    tipo_unidad_id: "",
    negocio_id: null,
  });
  const resetForm = () => {
    setForm({
      nombre_evento: "",
      estatus_evento_id: "",
      observaciones: "",
      evento_seguridad_id: "",
      lugar_remitido: "",
      tipo_de_apoyo: [],
      fechaAct: new Date().toLocaleString("es-MX", "America/Mexico_City"),
      negocio_id: null,
    });
  };

  useEffect(() => {
    if (!socket) return;

    // Suscribirse al evento
    socket.on("eventos_seguridad_", loadData);

    // Cargar los datos inicialmente
    loadData();

    // Limpieza: remover listener cuando el componente se desmonta o cambia el socket
    return () => {
      socket.off("eventos_seguridad_", loadData);
    };
  }, [socket]);

  // implementar .......................................................-.
  // socket.on("nueva-actualizacion-de-evento_", async () => {
  //     console.log("new act de event de robo, actualizando notificaciones");
  //     if (user.rol === "S.W.A.T") {
  //       let r = await getRegistroSeguridadEventos(true);
  //       if(r.ok){
  //         setRegistroSeguridadEventos(r.data);
  //       }
  //     }
  //   })
  // implementar .......................................................-.
  const loadData = async () => {
    setLoading(true);
    let r = await getRegistroSeguridadEventos(true);
    if (r.ok) {
      setRegistroSeguridadEventos(r.data);
      // setSeguimientoEvento(r.data.registro_evento_seguridads);
      setLoading(false);
    } else {
      setLoading(false);
      setRegistroSeguridadEventos([]);
    }

    let res = await getStatusEvento();
    if (res.ok) {
      setStatusEventoAutos(res.estatus.autos);
      setStatusEventoMotos(res.estatus.motos);
      setStatusEventoCamiones(res.estatus.camiones);
    }

    let respu = await getTipoApoyo();
    if (respu.ok) {
      setTipoApoyo(respu.tipos_apoyo);
    }
  };

  $(document).ready(function () {
    $("#descargaUpload").click(function () {
      alert("The paragraph was clicked.");
    });
  });

  const handleChange = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  const handleFileUpload = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const actualizarEventoRobo = async () => {
    if (loading) return;
    handleClose();
    setLoading(true);
    let resp = false;
    let formData = new FormData();
    formData.append("archivo", selectedFile);

    if (selectedFile !== null) {
      const validar = await postValidarArchivo(formData);
      if (!validar.ok) {
        setLoading(false);
        return Swal.fire({
          title: "¡Lo siento!",
          text: validar.msg,
          icon: "info",
        });
      }
    }

    resp = await postEventoSeguridad({
      evento_seguridad_id: form.evento_seguridad_id,
      estatus_evento_id: form.estatus_evento_id,
      fecha_hora: form.fechaAct,
      apoyo_tipo_id: form.tipo_de_apoyo,
      lugar: form.lugar_remitido,
      observaciones: form.observaciones,
    });

    if (resp.ok) {
      if (selectedFile === null) {
        resp = {
          ok: true,
          msg: "Sin archivos cargados",
        };
      } else {
        resp = await postFilesUploads(
          formData,
          resp.registro.registro_evento_id
        );
      }

      if (
        resp.ok &&
        form.estatus_evento_id !== 2 &&
        form.estatus_evento_id !== "2"
      ) {
        let res = await deleteRegistroEventoSeguridad(form.evento_seguridad_id);
        if (res.ok) {
          setLoading(false);
          Swal.fire({
            title: "REGISTRO DE EVENTO DE ROBO",
            text: "Finalizado correctamente",
            showConfirmButton: false,
            icon: "success",
            timer: 3000,
          });
          handleClose();
          resetForm();
          setSelectedFile(null);
          socket.emit("new_event_robo", { idNegocio: parseInt(form.negocio_id) });
          await timers.setTimeout(3000, "result").then((res) => {
            loadData();
          });
        } else {
          console.log("error al cargar el archivo");
          setLoading(false);
          Swal.fire({
            title: "Error",
            text: resp.msg,
            icon: "error",
          });
        }
      } else if (
        resp.ok &&
        (form.estatus_evento_id === 2 || form.estatus_evento_id === "2")
      ) {
        setLoading(false);
        Swal.fire({
          title: "REGISTRO DE EVENTO DE ROBO",
          text: "Actualizado correctamente",
          showConfirmButton: false,
          icon: "success",
          timer: 3000,
        });

        resetForm();
        setSelectedFile(null);
        await timers.setTimeout(3000, "result").then((res) => {
          loadData();
        });
      } else if (!resp.ok) {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: resp.msg,
          icon: "error",
        });
      }
    } else {
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: resp.msg,
        icon: "error",
      });
    }
  };

  function UncontrolledUnidades() {
    return (
      <>
        <Nav tabs className="eventos_unidades">
          {registroSeguridadEventos.map((evt, index) => {
            const numero = evt.unidad_numero
              || evt.unidad?.unidad_numero
              || evt.unidad?.unidad_vin?.slice(-4)  // fallback para tipo_unidad_id 4 sin número
              || evt.unidad_vin?.slice(-4);
            if (!numero) return null;

            const tipo = Number(evt.tipo_unidad_id);

            const estilo =
              tipo === 3
                ? { background: "#0066bf", color: "#FFF" }
                : tipo === 4
                  ? { background: "rgba(0,0,0,0.55)", color: "#FFF" }
                  : { background: "#ffcd00", color: "#000" };

            return (
              <NavItem key={evt.evento_seguridad_id}>
                <NavLink
                  className={classnames({ active: activeTab === index + 1 })}
                  onClick={() => toggle(index + 1)}
                  style={{ ...estilo, marginRight: "2px", fontWeight: "bold" }}
                >
                  {numero}
                </NavLink>
              </NavItem>
            );
          })}
        </Nav>
        <TabContent activeTab={activeTab}>
          {registroSeguridadEventos.map((evt, index) => {
            return (
              <>
                {evt.viaje ? (
                  <>
                    <TabPane key={index} tabId={index + 1}>
                      <Row>
                        <Col sm="12">
                          <div className="row" style={{ paddingTop: "20px" }}>
                            <div className="card mb-1 p-3 col-4">
                              <div className="row g-0">
                                <div className="col-md-5">
                                  <label style={{ padding: "2px" }}>
                                    <strong>Placas: </strong>
                                    <br />
                                    {evt.viaje.unidad.unidad_placas}
                                  </label>
                                  <br />
                                  <label style={{ padding: "2px" }}>
                                    <strong>Serie: </strong>
                                    <br /> {evt.viaje.unidad.unidad_vin}
                                  </label>
                                  <br />
                                  <label style={{ padding: "2px" }}>
                                    <strong>Marca: </strong>
                                    <br /> {evt.viaje.unidad.unidad_marca}
                                  </label>
                                  <br />
                                  <label style={{ padding: "2px" }}>
                                    <strong>SubMarca: </strong>
                                    <br /> {evt.viaje.unidad.unidad_modelo}
                                  </label>
                                  <br />
                                  <label style={{ padding: "2px" }}>
                                    <strong>Color: </strong>
                                    <br /> {evt.viaje.unidad.unidad_color}
                                  </label>
                                  <br />
                                  <label style={{ padding: "2px" }}>
                                    <strong>Negocio: </strong>
                                    <br />{" "}
                                    {evt.viaje.unidad.negocio.negocio_nombre}
                                  </label>
                                  <br />
                                  <label style={{ padding: "2px" }}>
                                    <strong>Cedis: </strong>
                                    <br /> {evt.viaje.unidad.cedi.nombre_cedis}
                                  </label>
                                </div>
                                <div
                                  className="col-md-7"
                                  style={{ borderLeft: "1px solid #CCC" }}
                                >
                                  <div
                                    className="card-body"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <h5
                                      className="card-title"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <strong>
                                        Unidad {evt.viaje.unidad.unidad_numero}
                                      </strong>
                                      {/* <strong>
                                        Caja seca {evt.viaje.unidad.unidad_numero}
                                      </strong> */}
                                    </h5>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Operador: </strong> <br />
                                        {evt.viaje.chofer.nombre_completo}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Numero de teléfono: </strong>
                                        <br />
                                        {evt.viaje.chofer.telefono}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>
                                          Último contacto con el operador:{" "}
                                        </strong>{" "}
                                        <br />
                                        {moment(
                                          evt.ultimo_contacto_conductor
                                        ).format("lll")}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Destinos: </strong>
                                        <br />
                                        {evt.viaje.ruta.map((ruta, index) => {
                                          return (
                                            ruta.tienda.tienda_nombre +
                                            (index > 0 ? "," : "")
                                          );
                                        })}
                                      </label>
                                    </div>
                                    <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                                      {evt.viaje.tripulantes_viajes?.map((item, index) => (
                                        <li key={index}>
                                          <strong>Tripulante: </strong> {item.tripulante?.nombre_completo} -{" "}
                                          {item.tripulante?.telefono}
                                        </li>
                                      ))}
                                    </ul>
                                    {evt.unidad.spot ? (
                                      <>
                                        <div className="col form-group pb-2">
                                          <label>
                                            <strong>
                                              Nombre de transportadora:{" "}
                                            </strong>
                                            <br />
                                            {evt.unidad.nombre_transportadora}
                                          </label>
                                        </div>
                                        <div className="col form-group pb-2">
                                          <label>
                                            <strong>Usuario spot: </strong>
                                            <br />
                                            {evt.usuario_spot}
                                          </label>
                                        </div>
                                        <div className="col form-group pb-2">
                                          <label>
                                            <strong>Contraseña spot: </strong>
                                            <br />
                                            {evt.contrasenia_spot}
                                          </label>
                                        </div>
                                        <div className="col form-group pb-2">
                                          <label>
                                            <strong>Liga spot: </strong>
                                            <br />
                                            {evt.liga_spot}
                                          </label>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card mb-1 p-3 col-8">
                              <div className="row g-0">
                                <div className="col-4">
                                  <div
                                    className="card-body"
                                    style={{
                                      fontSize: "16px",
                                      padding: "1rem 0px",
                                    }}
                                  >
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Fecha de registro: </strong>{" "}
                                        <br />
                                        {moment(evt.createdAt).format("lll")}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>
                                          Carpeta de investigación:{" "}
                                        </strong>{" "}
                                        <br />
                                        {evt.carpeta_investigacion}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>
                                          Coordenadas del lugar de evento:{" "}
                                        </strong>{" "}
                                        <br />
                                        {evt.coordenadas_inicio}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Chapas de seguridad: </strong>{" "}
                                        <br />
                                        {evt.chapa_seguridad}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Paro de motor: </strong> <br />
                                        {evt.paro_motor === 0 ? "NO" : "SI"}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="col-3"
                                  style={{ borderLeft: "1px solid #CCC" }}
                                >
                                  <div
                                    className="card-body"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Predenuncia: </strong> <br />
                                        {evt.predenuncia}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Modus operandi: </strong> <br />
                                        {evt.modus_operandi}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>AS3: </strong>
                                        {evt.activacion_as3}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>CCTV: </strong> <br />
                                        {evt.cctv ? "SI" : "NO"}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Vialidad: </strong> <br />
                                        {evt.vialidad}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Mercancía: </strong> <br />
                                        {evt.mercancia && "Si"}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="col-5 p-3"
                                  style={{ borderLeft: "1px solid #CCC" }}
                                >
                                  <div
                                    className="card-body"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <h5
                                      className="card-title"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <strong>FOLIO: {evt.folio}</strong>
                                    </h5>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Monitorista: </strong> <br />
                                        {evt.usuario.name}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Municipio/Alcaldía: </strong>{" "}
                                        <br />
                                        {evt.municipio.municipio}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Estado: </strong> <br />
                                        {evt.estado.entidad_federativa}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2 mx-auto">
                                      {/* {
                                                                                // <PDFDownloadLink document={}>
                                                                                    <button className="btn btn-success" onClick={() => {
                                                                                        setVerPdf(true);
                                                                                        setUnidadEventSeguridad(evt.evento_seguridad_id);
                                                                                        // formarPDF(evt.evento_seguridad_id);
                                                                                    }}>
                                                                                        Descargar PDF
                                                                                    </button>
                                                                                // </PDFDownloadLink>
                                                                                
                                                                            } */}
                                      {
                                        // <PDFDownloadLink
                                        //     document={
                                        //         <DocuPDFEventoSeguridad
                                        //             registroSeguridadEventos={registroSeguridadEventos}
                                        //             unidadEventSeguridad={evt.evento_seguridad_id}
                                        //         />
                                        //     }
                                        //     fileName={"Evento de unidad " + evt.viaje.unidad.unidad_numero}
                                        // >
                                        //     <button className="btn btn-success">
                                        //         Descargar PDF
                                        //     </button>
                                        // </PDFDownloadLink>
                                      }
                                      {
                                        <DocPDFEventoSeguridad
                                          registroSeguridadEventos={
                                            registroSeguridadEventos
                                          }
                                          unidadEventSeguridad={
                                            evt.evento_seguridad_id
                                          }
                                        />
                                      }
                                      <button
                                        style={{ marginLeft: "10px" }}
                                        className="btn btn-primary"
                                        onClick={() => {
                                          handleShow();
                                          setForm({
                                            ...form,
                                            evento_seguridad_id:
                                              evt.evento_seguridad_id,
                                            estatus_evento_id:
                                              evt.ultimo_estatus_id,
                                            tipo_unidad_id: evt.tipo_unidad_id,
                                            negocio_id: evt?.unidad?.negocio_id,
                                          });
                                        }}
                                      >
                                        Actualizar evento
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Accordion
                              defaultActiveKey="0"
                              style={{ padding: "0" }}
                            >
                              <Accordion.Item eventKey={index}>
                                <Accordion.Header>
                                  <strong
                                    style={{ textTransform: "uppercase" }}
                                  >
                                    EVENTO: {evt.evento.evento}
                                  </strong>
                                </Accordion.Header>
                                <Accordion.Body>
                                  <div
                                    className="table-responsive p-0 pb-2 pt-3"
                                    style={{ fontSize: "14px" }}
                                  >
                                    <table
                                      id={"table" + index}
                                      className="table align-items-center justify-content-center mb-0"
                                      style={{ width: "100%" }}
                                    >
                                      <thead>
                                        <tr>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            N°
                                          </th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            Estatus
                                          </th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            Fecha actualización
                                          </th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            Archivo
                                          </th>
                                          {/*<th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Corporaciones</th>
                                                                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Lugar remitido</th>*/}
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            Coordenadas
                                          </th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            Usuario
                                          </th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            Observaciones
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {evt.registro_evento_seguridads.map(
                                          (seguimiento, index) => {
                                            return (
                                              <tr key={index}>
                                                <td className="text-xs font-weight-bold text-center">
                                                  {index + 1}
                                                </td>
                                                <td className="text-xs font-weight-bold text-center">
                                                  {
                                                    seguimiento.estatus_evento
                                                      .estatus_evento
                                                  }
                                                </td>
                                                <td className="text-xs font-weight-bold text-center">
                                                  {moment(
                                                    seguimiento.updatedAt
                                                  ).format("lll")}
                                                </td>
                                                <td className="text-xs font-weight-bold text-center">
                                                  {seguimiento.url !== null ? (
                                                    <a
                                                      href={
                                                        process.env
                                                          .REACT_APP_API_URL_LOCAL +
                                                        "eventos-seguridad/download/" +
                                                        seguimiento.registro_evento_id
                                                      }
                                                      download="archivo"
                                                      className="btn btn-outline-primary"
                                                      style={{
                                                        padding: "3% 11%",
                                                      }}
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faDownload}
                                                        className="pull-left f12"
                                                      />
                                                    </a>
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                                {/* <td className="text-xs font-weight-bold text-center">
                                                                                                        {
                                                                                                            seguimiento.tipo_apoyo_riesgos.map((apoyo, index) => {
                                                                                                                return (
                                                                                                                    apoyo.apoyo_tipo.apoyo_tipo + ", "  
                                                                                                                )
                                                                                                                
                                                                                                            })
                                                                                                        }
                                                                                                    </td>
                                                                                                    <td className="text-xs font-weight-bold text-center">{seguimiento.lugar}</td> */}
                                                <td className="text-xs font-weight-bold text-center">
                                                  {seguimiento.coordenadas_online !==
                                                    null
                                                    ? seguimiento.fecha_coordenadas_online !==
                                                      null
                                                      ? moment(
                                                        seguimiento.fecha_coordenadas_online
                                                      ).format("lll") +
                                                      " " +
                                                      seguimiento.coordenadas_online
                                                      : seguimiento.coordenadas_online
                                                    : ""}
                                                </td>
                                                <td className="text-xs font-weight-bold text-center">
                                                  {seguimiento.usuario.name}
                                                </td>
                                                <td className="text-xs font-weight-bold text-center">
                                                  {seguimiento.observaciones}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  </>
                ) : evt.tipo_unidad_id === 1 && (
                  <>
                    <TabPane key={index} tabId={index + 1}>
                      <Row>
                        <Col sm="12">
                          <div className="row" style={{ paddingTop: "20px" }}>
                            <div className="card mb-1 p-3 col-4">
                              <div className="row g-0">
                                <div className="col-md-5">
                                  <label style={{ padding: "2px" }}>
                                    <strong>Placas: </strong>
                                    <br />
                                    {evt.unidad.unidad_placas}
                                  </label>
                                  <br />
                                  <label style={{ padding: "2px" }}>
                                    <strong>Serie: </strong>
                                    <br /> {evt.unidad.unidad_vin}
                                  </label>
                                  <br />
                                  <label style={{ padding: "2px" }}>
                                    <strong>Marca: </strong>
                                    <br /> {evt.unidad.unidad_marca}
                                  </label>
                                  <br />
                                  <label style={{ padding: "2px" }}>
                                    <strong>SubMarca: </strong>
                                    <br /> {evt.unidad.unidad_modelo}
                                  </label>
                                  <br />
                                  <label style={{ padding: "2px" }}>
                                    <strong>Color: </strong>
                                    <br /> {evt.unidad.unidad_color}
                                  </label>
                                  <br />
                                  <label style={{ padding: "2px" }}>
                                    <strong>Negocio: </strong>
                                    <br />{" "}
                                    {evt.unidad.negocio}
                                  </label>
                                  <br />
                                  <label style={{ padding: "2px" }}>
                                    <strong>Cedis: </strong>
                                    <br /> {evt.unidad.cedis}
                                  </label>
                                </div>
                                <div
                                  className="col-md-7"
                                  style={{ borderLeft: "1px solid #CCC" }}
                                >
                                  <div
                                    className="card-body"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <h5
                                      className="card-title"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <strong>
                                        Unidad {evt.unidad.unidad_numero}
                                      </strong>
                                    </h5>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Operador: </strong> <br />
                                        {evt?.tripulantes?.chofer?.nombre_completo}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Numero de teléfono: </strong>
                                        <br />
                                        {evt?.tripulantes?.chofer?.telefono}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>
                                          Último contacto con el operador:{" "}
                                        </strong>{" "}
                                        <br />
                                        {moment(
                                          evt.ultimo_contacto_conductor
                                        ).format("lll")}
                                      </label>
                                    </div>
                                    {/* <div className="col form-group pb-2">
                                      <label>
                                        <strong>Destinos: </strong>
                                        <br />
                                        {evt.viaje.ruta.map((ruta, index) => {
                                          return (
                                            ruta.tienda.tienda_nombre +
                                            (index > 0 ? "," : "")
                                          );
                                        })}
                                      </label>
                                    </div> */}
                                    <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                                      {evt?.tripulantes?.tripulacion?.map((item, index) => (
                                        <li key={index}>
                                          <strong>Tripulante: </strong> {item?.nombre_completo} -{" "}
                                          {item?.telefono}
                                        </li>
                                      ))}
                                    </ul>
                                    {evt.unidad.spot ? (
                                      <>
                                        <div className="col form-group pb-2">
                                          <label>
                                            <strong>
                                              Nombre de transportadora:{" "}
                                            </strong>
                                            <br />
                                            {evt.unidad.nombre_transportadora}
                                          </label>
                                        </div>
                                        <div className="col form-group pb-2">
                                          <label>
                                            <strong>Usuario spot: </strong>
                                            <br />
                                            {evt.usuario_spot}
                                          </label>
                                        </div>
                                        <div className="col form-group pb-2">
                                          <label>
                                            <strong>Contraseña spot: </strong>
                                            <br />
                                            {evt.contrasenia_spot}
                                          </label>
                                        </div>
                                        <div className="col form-group pb-2">
                                          <label>
                                            <strong>Liga spot: </strong>
                                            <br />
                                            {evt.liga_spot}
                                          </label>
                                        </div>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card mb-1 p-3 col-8">
                              <div className="row g-0">
                                <div className="col-4">
                                  <div
                                    className="card-body"
                                    style={{
                                      fontSize: "16px",
                                      padding: "1rem 0px",
                                    }}
                                  >
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Fecha de registro: </strong>{" "}
                                        <br />
                                        {moment(evt.createdAt).format("lll")}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>
                                          Carpeta de investigación:{" "}
                                        </strong>{" "}
                                        <br />
                                        {evt.carpeta_investigacion}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>
                                          Coordenadas del lugar de evento:{" "}
                                        </strong>{" "}
                                        <br />
                                        {evt.coordenadas_inicio}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Chapas de seguridad: </strong>{" "}
                                        <br />
                                        {evt.chapa_seguridad}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Paro de motor: </strong> <br />
                                        {evt.paro_motor === 0 ? "NO" : "SI"}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="col-3"
                                  style={{ borderLeft: "1px solid #CCC" }}
                                >
                                  <div
                                    className="card-body"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Predenuncia: </strong> <br />
                                        {evt.predenuncia}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Modus operandi: </strong> <br />
                                        {evt.modus_operandi}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>AS3: </strong>
                                        {evt.activacion_as3}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>CCTV: </strong> <br />
                                        {evt.cctv ? "SI" : "NO"}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Vialidad: </strong> <br />
                                        {evt.vialidad}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Mercancía: </strong> <br />
                                        {evt.mercancia && "Si"}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="col-5 p-3"
                                  style={{ borderLeft: "1px solid #CCC" }}
                                >
                                  <div
                                    className="card-body"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <h5
                                      className="card-title"
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <strong>FOLIO: {evt.folio}</strong>
                                    </h5>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Monitorista: </strong> <br />
                                        {evt.usuario.name}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Municipio/Alcaldía: </strong>{" "}
                                        <br />
                                        {evt.municipio.municipio}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>Estado: </strong> <br />
                                        {evt.estado.entidad_federativa}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2 mx-auto">
                                      {
                                        <DocPDFEventoSeguridad
                                          registroSeguridadEventos={
                                            registroSeguridadEventos
                                          }
                                          unidadEventSeguridad={
                                            evt.evento_seguridad_id
                                          }
                                        />
                                      }
                                      <button
                                        style={{ marginLeft: "10px" }}
                                        className="btn btn-primary"
                                        onClick={() => {
                                          handleShow();
                                          setForm({
                                            ...form,
                                            evento_seguridad_id:
                                              evt.evento_seguridad_id,
                                            estatus_evento_id:
                                              evt.ultimo_estatus_id,
                                            tipo_unidad_id: evt.tipo_unidad_id,
                                          });
                                        }}
                                      >
                                        Actualizar evento
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <Accordion
                              defaultActiveKey="0"
                              style={{ padding: "0" }}
                            >
                              <Accordion.Item eventKey={index}>
                                <Accordion.Header>
                                  <strong
                                    style={{ textTransform: "uppercase" }}
                                  >
                                    EVENTO: {evt.evento.evento}
                                  </strong>
                                </Accordion.Header>
                                <Accordion.Body>
                                  <div
                                    className="table-responsive p-0 pb-2 pt-3"
                                    style={{ fontSize: "14px" }}
                                  >
                                    <table
                                      id={"table" + index}
                                      className="table align-items-center justify-content-center mb-0"
                                      style={{ width: "100%" }}
                                    >
                                      <thead>
                                        <tr>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            N°
                                          </th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            Estatus
                                          </th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            Fecha actualización
                                          </th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            Archivo
                                          </th>
                                          {/*<th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Corporaciones</th>
                                                                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Lugar remitido</th>*/}
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            Coordenadas
                                          </th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            Usuario
                                          </th>
                                          <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                            Observaciones
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {evt.registro_evento_seguridads.map(
                                          (seguimiento, index) => {
                                            return (
                                              <tr key={index}>
                                                <td className="text-xs font-weight-bold text-center">
                                                  {index + 1}
                                                </td>
                                                <td className="text-xs font-weight-bold text-center">
                                                  {
                                                    seguimiento.estatus_evento
                                                      .estatus_evento
                                                  }
                                                </td>
                                                <td className="text-xs font-weight-bold text-center">
                                                  {moment(
                                                    seguimiento.updatedAt
                                                  ).format("lll")}
                                                </td>
                                                <td className="text-xs font-weight-bold text-center">
                                                  {seguimiento.url !== null ? (
                                                    <a
                                                      href={
                                                        process.env
                                                          .REACT_APP_API_URL_LOCAL +
                                                        "eventos-seguridad/download/" +
                                                        seguimiento.registro_evento_id
                                                      }
                                                      download="archivo"
                                                      className="btn btn-outline-primary"
                                                      style={{
                                                        padding: "3% 11%",
                                                      }}
                                                    >
                                                      <FontAwesomeIcon
                                                        icon={faDownload}
                                                        className="pull-left f12"
                                                      />
                                                    </a>
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                                {/* <td className="text-xs font-weight-bold text-center">
                                                                                                        {
                                                                                                            seguimiento.tipo_apoyo_riesgos.map((apoyo, index) => {
                                                                                                                return (
                                                                                                                    apoyo.apoyo_tipo.apoyo_tipo + ", "  
                                                                                                                )
                                                                                                                
                                                                                                            })
                                                                                                        }
                                                                                                    </td>
                                                                                                    <td className="text-xs font-weight-bold text-center">{seguimiento.lugar}</td> */}
                                                <td className="text-xs font-weight-bold text-center">
                                                  {seguimiento.coordenadas_online !==
                                                    null
                                                    ? seguimiento.fecha_coordenadas_online !==
                                                      null
                                                      ? moment(
                                                        seguimiento.fecha_coordenadas_online
                                                      ).format("lll") +
                                                      " " +
                                                      seguimiento.coordenadas_online
                                                      : seguimiento.coordenadas_online
                                                    : ""}
                                                </td>
                                                <td className="text-xs font-weight-bold text-center">
                                                  {seguimiento.usuario.name}
                                                </td>
                                                <td className="text-xs font-weight-bold text-center">
                                                  {seguimiento.observaciones}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  </>
                )}
                {evt.unidad_vin ? (
                  <>
                    <TabPane key={index} tabId={index + 1}>
                      <div className="row" style={{ paddingTop: "20px" }}>
                        <div className="card mb-1 p-3 col-4">
                          <div className="row g-0">
                            <div className="col-md-5">
                              <label style={{ padding: "2px" }}>
                                <strong>Placas: </strong>
                                <br /> {evt.unidad.unidad_placas}
                              </label>
                              <br />
                              <label style={{ padding: "2px" }}>
                                <strong>Serie: </strong>
                                <br /> {evt.unidad.unidad_vin}
                              </label>
                              <br />
                              <label style={{ padding: "2px" }}>
                                <strong>Marca: </strong>
                                <br /> {evt.unidad.unidad_marca}
                              </label>
                              <br />
                              <label style={{ padding: "2px" }}>
                                <strong>Modelo: </strong>
                                <br /> {evt.unidad.unidad_modelo}
                              </label>
                              <br />
                              <label style={{ padding: "2px" }}>
                                <strong>Color: </strong>
                                <br /> {evt.unidad.unidad_color}
                              </label>
                            </div>
                            <div
                              className="col-md-7"
                              style={{ borderLeft: "1px solid #CCC" }}
                            >
                              <div
                                className="card-body"
                                style={{ fontSize: "16px" }}
                              >
                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>UNIDAD: </strong> <br />
                                    {evt.unidad_vin}
                                  </label>
                                </div>
                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>Cliente: </strong> <br />{" "}
                                    {evt.unidad.cliente}
                                  </label>
                                </div>
                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>Numero de teléfono: </strong>
                                    <br /> {evt.unidad.cliente_gestor_telefono}
                                  </label>
                                </div>
                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>Fecha de registro: </strong> <br />
                                    {moment(evt.createdAt).format("lll")}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card mb-1 p-3 col-8">
                          <div className="row g-0">
                            <div className="col-4">
                              <div
                                className="card-body"
                                style={{
                                  fontSize: "16px",
                                  padding: "1rem 0px",
                                }}
                              >
                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>Carpeta de investigación: </strong>{" "}
                                    <br />
                                    {evt.carpeta_investigacion}
                                  </label>
                                </div>
                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>
                                      Coordenadas del lugar de evento:{" "}
                                    </strong>{" "}
                                    <br />
                                    {evt.coordenadas_inicio}
                                  </label>
                                </div>
                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>Predenuncia: </strong> <br />
                                    {evt.predenuncia}
                                  </label>
                                </div>
                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>Paro de motor: </strong> <br />
                                    {evt.paro_motor === 0 ? "NO" : "SI"}
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-3"
                              style={{ borderLeft: "1px solid #CCC" }}
                            >
                              <div
                                className="card-body"
                                style={{ fontSize: "16px" }}
                              >
                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>Modus operandi: </strong> <br />
                                    {evt.modus_operandi}
                                  </label>
                                </div>
                                {evt.tipo_unidad_id === 3 ? (
                                  <>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>AS4: </strong>
                                        {evt.activacion_as3}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>GPS reportando: </strong>
                                        {evt.gps_reportando ? "SI" : "NO"}
                                      </label>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}

                                {evt.tipo_unidad_id === 4 ? (
                                  <>
                                    {evt.activacion_as3 && (
                                      <>
                                        <div className="col form-group pb-2">
                                          <label>
                                            <strong>AS3: </strong>
                                            {evt.activacion_as3}
                                          </label>
                                        </div>
                                      </>
                                    )}
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>CCTV: </strong>
                                        {evt.cctv ? "SI" : "NO"}
                                      </label>
                                    </div>
                                    <div className="col form-group pb-2">
                                      <label>
                                        <strong>GPS reportando: </strong>
                                        {evt.gps_reportando ? "SI" : "NO"}
                                      </label>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}

                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>Vialidad: </strong> <br />
                                    {evt.vialidad}
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-5 p-3"
                              style={{ borderLeft: "1px solid #CCC" }}
                            >
                              <div
                                className="card-body"
                                style={{ fontSize: "16px" }}
                              >
                                <h5
                                  className="card-title"
                                  style={{ fontWeight: "bold" }}
                                >
                                  <strong>FOLIO: {evt.folio}</strong>
                                </h5>
                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>Monitorista: </strong> <br />
                                    {evt.usuario.name}
                                  </label>
                                </div>
                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>Municipio/Alcaldía: </strong> <br />
                                    {evt.municipio.municipio}
                                  </label>
                                </div>
                                <div className="col form-group pb-2">
                                  <label>
                                    <strong>Estado: </strong> <br />
                                    {evt.estado.entidad_federativa}
                                  </label>
                                </div>
                                <div className="col form-group pb-2 mx-auto">
                                  {/* {
                                                                                // <PDFDownloadLink document={}>
                                                                                    <button className="btn btn-success" onClick={() => {
                                                                                        setVerPdf(true);
                                                                                        setUnidadEventSeguridad(evt.evento_seguridad_id);
                                                                                        // formarPDF(evt.evento_seguridad_id);
                                                                                    }}>
                                                                                        Descargar PDF
                                                                                    </button>
                                                                                // </PDFDownloadLink>
                                                                                
                                                                            } */}
                                  {
                                    // <PDFDownloadLink
                                    //     document={
                                    //         // <DocuPDFEventoSeguridad
                                    //         //     registroSeguridadEventos={registroSeguridadEventos}
                                    //         //     unidadEventSeguridad={evt.evento_seguridad_id}
                                    //         // />
                                    //         <DocPDFEventoSeguridad/>
                                    //     }
                                    //     fileName={"Evento de unidad " + evt.unidad_vin}
                                    // >
                                    //     <button className="btn btn-success">
                                    //         Descargar PDF
                                    //     </button>
                                    // </PDFDownloadLink>
                                  }
                                  {
                                    <DocPDFEventoSeguridad
                                      registroSeguridadEventos={
                                        registroSeguridadEventos
                                      }
                                      unidadEventSeguridad={
                                        evt.evento_seguridad_id
                                      }
                                    />
                                  }
                                  <button
                                    style={{ marginLeft: "10px" }}
                                    className="btn btn-primary"
                                    onClick={() => {
                                      handleShow();
                                      setForm({
                                        ...form,
                                        evento_seguridad_id:
                                          evt.evento_seguridad_id,
                                        estatus_evento_id:
                                          evt.ultimo_estatus_id,
                                        tipo_unidad_id: evt.tipo_unidad_id,
                                      });
                                    }}
                                  >
                                    Actualizar evento
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <Accordion
                          defaultActiveKey="0"
                          style={{ padding: "0" }}
                        >
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              <strong style={{ textTransform: "uppercase" }}>
                                EVENTO: {evt.evento.evento}
                              </strong>
                            </Accordion.Header>
                            <Accordion.Body>
                              <div
                                className="table-responsive p-0 pb-2 pt-3"
                                style={{ fontSize: "14px" }}
                              >
                                <table
                                  id={"table" + index}
                                  className="table align-items-center justify-content-center mb-0"
                                  style={{ width: "100%" }}
                                >
                                  <thead>
                                    <tr>
                                      <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                        N°
                                      </th>
                                      <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                        Estatus
                                      </th>
                                      <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                        Fecha actualización
                                      </th>
                                      <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                        Archivo
                                      </th>
                                      {/*<th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Corporaciones</th>
                                                                                        <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">Lugar remitido</th>*/}
                                      <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                        Coordenadas
                                      </th>
                                      <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                        Usuario
                                      </th>
                                      <th className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ps-2">
                                        Observaciones
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {evt.registro_evento_seguridads.map(
                                      (seguimiento, index) => {
                                        return (
                                          <tr key={index}>
                                            <td className="text-xs font-weight-bold text-center">
                                              {index + 1}
                                            </td>
                                            <td className="text-xs font-weight-bold text-center">
                                              {
                                                seguimiento.estatus_evento
                                                  .estatus_evento
                                              }
                                            </td>
                                            <td className="text-xs font-weight-bold text-center">
                                              {moment(
                                                seguimiento.updatedAt
                                              ).format("lll")}
                                            </td>
                                            <td className="text-xs font-weight-bold text-center">
                                              {seguimiento.url !== null ? (
                                                <a
                                                  href={
                                                    process.env
                                                      .REACT_APP_API_URL_LOCAL +
                                                    "eventos-seguridad/download/" +
                                                    seguimiento.registro_evento_id
                                                  }
                                                  download="archivo"
                                                  className="btn btn-outline-primary"
                                                  style={{ padding: "3% 11%" }}
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faDownload}
                                                    className="pull-left f12"
                                                  />
                                                </a>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            {/* <td className="text-xs font-weight-bold text-center">
                                                                                                        {
                                                                                                            seguimiento.tipo_apoyo_riesgos.map((apoyo, index) => {
                                                                                                                return (
                                                                                                                    apoyo.apoyo_tipo.apoyo_tipo + ", "  
                                                                                                                )
                                                                                                                
                                                                                                            })
                                                                                                        }
                                                                                                    </td>
                                                                                                    <td className="text-xs font-weight-bold text-center">{seguimiento.lugar}</td> */}
                                            <td className="text-xs font-weight-bold text-center">
                                              {seguimiento.coordenadas_online !==
                                                null
                                                ? seguimiento.fecha_coordenadas_online !==
                                                  null
                                                  ? moment(
                                                    seguimiento.fecha_coordenadas_online
                                                  ).format("lll") +
                                                  " " +
                                                  seguimiento.coordenadas_online
                                                  : seguimiento.coordenadas_online
                                                : ""}
                                            </td>
                                            <td className="text-xs font-weight-bold text-center">
                                              {seguimiento.usuario.name}
                                            </td>
                                            <td className="text-xs font-weight-bold text-center">
                                              {seguimiento.observaciones}
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>
                    </TabPane>
                  </>
                ) : (
                  ""
                )}
              </>
            );
          })}
        </TabContent>
      </>
    );
  }

  const toggle = async (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const fileUpload = async (registro_evento_id) => {
    const url = `http://localhost:4000/api/eventos-seguridad/download/${registro_evento_id}`;
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, "filename");
      });
  };

  return (
    <>
      {loading && <Spinner />}
      <div>
        {registroSeguridadEventos ? UncontrolledUnidades() : "no existen datos"}
        {registroSeguridadEventos ? (
          <>
            {verPDF ? (
              <PDFViewer style={{ width: "100%", height: "90vh" }}>
                <DocuPDFEventoSeguridad
                  registroSeguridadEventos={registroSeguridadEventos}
                  unidadEventSeguridad={unidadEventSeguridad}
                />
              </PDFViewer>
            ) : null}
          </>
        ) : (
          ""
        )}
        <Modal show={show2} onHide={handleClose} backdrop="static" size="lg">
          <Modal.Header>
            <h3> ACTUALIZACIÓN DE EVENTO</h3>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-6">
                <div className="col form-group">
                  <label>Estatus Evento</label>
                  <select
                    value={form.estatus_evento_id}
                    className="form-control mt-2"
                    name="estatus_evento_id"
                    onChange={handleChange}
                    required
                  >
                    <option value="">Selecciona estatus evento</option>

                    {form.tipo_unidad_id === 3
                      ? statusEventoMotos.map((x) => (
                        <option
                          value={`${x.estatus_evento_id}`}
                          key={x.estatus_evento_id}
                        >
                          {x.estatus_evento}
                        </option>
                      ))
                      : form.tipo_unidad_id === 4
                        ? statusEventoAutos.map((x) => (
                          <option
                            value={`${x.estatus_evento_id}`}
                            key={x.estatus_evento_id}
                          >
                            {x.estatus_evento}
                          </option>
                        ))
                        : form.tipo_unidad_id === 1
                          ? statusEventoCamiones.map((x) => (
                            <option
                              value={`${x.estatus_evento_id}`}
                              key={x.estatus_evento_id}
                            >
                              {x.estatus_evento}
                            </option>
                          ))
                          : ""}
                  </select>
                </div>
              </div>
              <div className="col-6">
                <label>Fecha actualización</label>
                <input
                  type="text"
                  className="form-control"
                  value={form.fechaAct}
                  disabled
                />
              </div>
              <div className="col-12">
                <div className="form-group">
                  <label>Cargar archivo</label>

                  <input
                    style={{ marginTop: "8px" }}
                    name="cargar_archivo"
                    className="form-control mb-3"
                    type="file"
                    accept=".xlsx,.xls, .csv/*,.doc, .docx, .pdf, image/*, video/mp4"
                    onChange={handleFileUpload}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <label>Lugar donde será remitida</label>
                  <input
                    type="text"
                    name="lugar_remitido"
                    className="form-control mb-3"
                    value={form.lugar_remitido}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="col form-group">
                  <label>Corporaciones </label>
                  <Select
                    name="tipo_de_apoyo"
                    options={tipoApoyo.map((x) => {
                      return { value: x.apoyo_tipo_id, label: x.apoyo_tipo };
                    })}
                    isMulti
                    className="form-control mt-2"
                    classNamePrefix={"select"}
                    value={form.tipo_de_apoyo}
                    onChange={(event) => {
                      let aux = [];
                      event.forEach((label) => {
                        aux.push(label);
                      });

                      setForm({ ...form, tipo_de_apoyo: aux });
                    }}
                    placeholder="Selecciona el tipo de apoyo"
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <label>Observaciones</label>
                  <textarea
                    className="form-control mb-3"
                    rows="3"
                    name="observaciones"
                    value={form.observaciones}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => actualizarEventoRobo()} disabled={loading}>
              {loading ? "Actualizando..." : "Actualizar"}
            </Button>
            <Button
              variant="secondary"
              onClick={() => (handleClose(), resetForm())}
            >
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
